import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Partner_Service_URL } from "../Url";

export const saveapprovalactions = {
  SAVE_APPROVED_DETAILS_SUCCESS: "SAVE_APPROVED_DETAILS_SUCCESS",
  SAVE_APPROVED_DETAILS_ERROR: "SAVE_APPROVED_DETAILS_ERROR",
};

export function saveApprovalDetails(props) {
  const { access_token, values, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/approvePartnerVerificationInfo?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveApprovalApplicantDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveApprovalApplicantDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveApprovalApplicantDetailsError(err));
          return err.response;
        }
      });
}

export function saveApprovalApplicantDetailsError(error) {
  return {
    type: saveapprovalactions.SAVE_APPROVED_DETAILS_ERROR,
    payload: error,
  };
}

export function saveApprovalApplicantDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveapprovalactions.SAVE_APPROVED_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export const rejectApproval = {
  SAVE_REJECT_DETAILS_SUCCESS: "SAVE_REJECT_DETAILS_SUCCESS",
  SAVE_REJECT_DETAILS_ERROR: "SAVE_REJECT_DETAILS_ERROR",
};

export function saveRejectDetails(props) {
  const { access_token, data, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/rejectedPartnerVerificationInfo?partnerFirmId=${partnerFirmId}`,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveRejectApplicantDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveRejectApplicantDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveRejectApplicantDetailsError(err));
          return err.response;
        }
      });
}

export function saveRejectApplicantDetailsError(error) {
  return {
    type: rejectApproval.SAVE_REJECT_DETAILS_ERROR,
    payload: error,
  };
}

export function saveRejectApplicantDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: rejectApproval.SAVE_REJECT_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
